import { render } from "./KpiModal.vue?vue&type=template&id=79eb0516&scoped=true&ts=true"
import script from "./KpiModal.vue?vue&type=script&lang=ts"
export * from "./KpiModal.vue?vue&type=script&lang=ts"

import "./KpiModal.vue?vue&type=style&index=0&id=79eb0516&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79eb0516"]])

export default __exports__